import { render, staticRenderFns } from "./ArchivedCustomers.vue?vue&type=template&id=ee1dd910&scoped=true"
import script from "./ArchivedCustomers.vue?vue&type=script&lang=js"
export * from "./ArchivedCustomers.vue?vue&type=script&lang=js"
import style0 from "./ArchivedCustomers.vue?vue&type=style&index=0&id=ee1dd910&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1dd910",
  null
  
)

export default component.exports